export default "__VITE_ASSET__ad7728e6__"